import { Unity, useUnityContext } from "react-unity-webgl";
import { useLocation } from "react-router-dom";

function useUnityWrapper() {
  const props = useLocation().state;
  let name = props.name.charAt(0).toUpperCase() + props.name.slice(1)
  console.log(props.name);
  const {
    unityProvider,
    addEventListener,
    removeEventListener,
    sendMessage,
    isLoaded,
    unload,
    requestFullscreen,
    loadingProgression,
    UNSAFE__unityInstance,
  } = useUnityContext({
    

    loaderUrl: `https://storage.googleapis.com/ga-site-assets/games/${name}/${name}.loader.js`,
    dataUrl: `https://storage.googleapis.com/ga-site-assets/games/${name}/${name}.data`,
    frameworkUrl: `https://storage.googleapis.com/ga-site-assets/games/${name}/${name}.framework.js`,
    codeUrl: `https://storage.googleapis.com/ga-site-assets/games/${name}/${name}.wasm`,
    webglContextAttributes: {
      preserveDrawingBuffer: true,
    },
  });

  return {
    Unity,
    unityProvider,
    addEventListener,
    removeEventListener,
    sendMessage,
    isLoaded,
    unload,
    requestFullscreen,
    loadingProgression,
    UNSAFE__unityInstance,
  };
}
export default useUnityWrapper;
